import { ITextProcessorMiddleware } from 'components/RichTextEditor/processor/constants'
import { createRange } from 'components/RichTextEditor/processor/range'
import {
  getSelection,
  getSlices,
} from 'components/RichTextEditor/processor/selectors/textProcessorSelectors'

import { getValidSelection } from '../selection'

export const createSelectBlockMiddleware =
  (sliceType: string): ITextProcessorMiddleware =>
  (api) =>
  (next) =>
  (action) => {
    if (!action || action.type !== 'select') {
      return next(action)
    }
    const state = api.getState()
    const slices = getSlices(state).filter((slice) => slice.type === sliceType)
    const previousSelection = getSelection(state)
    const currentSelection = createRange(action.start, action.length)
    const fixedSelection = getValidSelection(currentSelection, previousSelection, slices)
    action.start = fixedSelection.start
    action.length = fixedSelection.length
    return next(action)
  }
